/**
 * Workspace boot (TPA client workspaces).
 *
 * A person who may open more than one workspace picks one after sign-in.
 * The choice is remembered on this browser, so later sign-ins reopen the
 * same workspace without asking (the server still verifies the access on
 * every switch and every request). Standalone users have one workspace and
 * never see any of this.
 *
 * Returns true when it took over navigation (caller must stop), false when
 * the caller should continue its normal landing.
 */
const API = process.env.REACT_APP_API_URL || '';
export const LAST_WORKSPACE_KEY = 'pcg_last_workspace';

export function rememberWorkspace(orgId) {
  try { localStorage.setItem(LAST_WORKSPACE_KEY, orgId); } catch { /* ignore */ }
}

export function forgetWorkspace() {
  try { localStorage.removeItem(LAST_WORKSPACE_KEY); } catch { /* ignore */ }
}

export async function switchWorkspace(orgId) {
  const res = await fetch(`${API}/api/auth/workspaces/${orgId}/switch`, {
    method: 'POST',
    credentials: 'include',
    headers: { 'Content-Type': 'application/json' },
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok || !data.success) return { ok: false, message: data.message || 'Could not open workspace' };
  rememberWorkspace(orgId);
  return { ok: true, switched: !!data.switched };
}

export function ensureWorkspace(user, navigate) {
  const count = user?.workspace?.workspaces_count || 1;
  if (count <= 1) return false;

  let last = null;
  try { last = localStorage.getItem(LAST_WORKSPACE_KEY); } catch { /* ignore */ }

  if (!last) {
    navigate('/workspaces', { replace: true });
    return true;
  }
  if (last === user.organization_id) return false;

  // Reopen the remembered workspace. If access ended, ask again.
  switchWorkspace(last).then((r) => {
    if (r.ok) { window.location.href = '/'; }
    else { forgetWorkspace(); navigate('/workspaces', { replace: true }); }
  }).catch(() => { forgetWorkspace(); navigate('/workspaces', { replace: true }); });
  return true;
}
